import { JSX } from 'react'
import { GoArrowDownRight, GoArrowUpRight } from 'react-icons/go'

import { BodyPart } from '../../api/services/body_parts/types.ts'
import { FlatBodyMeasurement } from '../../api/services/dd_panel_body_measurements/types.ts'
import { getBodyPartName } from './helpers.ts'

type TableColumn = {
  header: string
  accessor: string
  render?: (data: FlatBodyMeasurement) => JSX.Element
  className?: string
  classNameTd?: string
  sorted?: boolean
}

export const setBodyPartsTableColumns = (bodyParts: BodyPart[]) => {
  const columns: TableColumn[] = [
    {
      header: 'Data pomiaru',
      accessor: 'measured_at',
      render: (row: FlatBodyMeasurement) => (
        <p className={'text-xm'}>{row.measured_at}</p>
      ),
      className: 'w-[140px]'
    }
  ]

  if (bodyParts.length > 0) {
    bodyParts.map((bp) => {
      columns.push({
        header: getBodyPartName(bp.id, bodyParts),
        accessor: `body_part_${bp.id}`,
        render: (row: FlatBodyMeasurement) => {
          const key = `body_part_${bp.id}` as keyof FlatBodyMeasurement
          const keyPrev = `previous_${bp.id}` as keyof FlatBodyMeasurement

          const previous = Number(row[keyPrev])
          const current = Number(row[key])
          const result = Math.round((previous - current) * 10) / 10

          return (
            <p className={'flex flex-row text-xm'}>
              {row[key]}
              {result !== 0 && row[key] !== '-' && row[keyPrev] !== '-' ? (
                result > 0 ? (
                  <GoArrowDownRight color={'#008700'} size={20} />
                ) : (
                  <GoArrowUpRight color={'#F00'} size={20} />
                )
              ) : (
                ''
              )}
            </p>
          )
        },
        className: 'w-[100px] 2xl:w-auto'
      })
    })
  }

  columns.push({
    header: 'Dodający',
    accessor: 'created_by_dietitian',
    render: (row: FlatBodyMeasurement) => (
      <p className={'text-xm'}>
        {row.created_by_dietitian ? (
          <span
            className={
              'inline-flex max-w-full min-w-0 rounded-xl py-1 px-2 bg-green-600 text-white'
            }
          >
            Dietetyk
          </span>
        ) : (
          <span className={'px-2'}>Pacjent</span>
        )}
      </p>
    ),
    className: 'w-[120px]'
  })

  return columns
}
